import { useRef, useEffect, useState } from 'react';
import { useCursor } from '@/contexts/CursorContext';
import { useIsMobile } from '@/hooks';
import { useMouseTrail } from '@/hooks/useMouseTrail';
import styles from './Cursor.module.css';

// Detect if device has a fine pointer (mouse) vs coarse (touch)
const useIsTouchDevice = () => {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    // Check for touch capability or coarse pointer (mobile/tablet)
    const isTouchDevice =
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      window.matchMedia('(pointer: coarse)').matches;
    setIsTouch(isTouchDevice);
  }, []);

  return isTouch;
};

const CursorInner = () => {
  const { state } = useCursor();
  const circleRef = useRef<HTMLDivElement | null>(null);
  const trailRef = useRef<SVGSVGElement | null>(null);
  const isTouch = useIsTouchDevice();

  useMouseTrail({ trailRef, circleRef });

  useEffect(() => {
    // Skip effect on touch devices
    if (isTouch) return;

    if (!circleRef.current) return;

    const el = circleRef.current;
    const svg = trailRef.current;

    if (state === 'default') {
      el.querySelector('span')?.classList.add(styles.hidePlay);
    }
    if (state === 'other') {
      el.classList.add(styles.whitebg);
      el.querySelector('span')?.classList.remove(styles.hidePlay);
      svg?.classList.add('hideSvgCursorTrail');
    } else {
      el.classList.remove(styles.whitebg);
      el.querySelector('span')?.classList.add(styles.hidePlay);
      svg?.classList.remove('hideSvgCursorTrail');
    }
    if (state === 'link') {
      el?.classList.add(styles.hoverLink);
    } else {
      el?.classList.remove(styles.hoverLink);
    }
  }, [state, isTouch]);

  // Don't render cursor on touch devices
  if (isTouch) {
    return null;
  }

  return (
    <>
      <div ref={circleRef} className={styles.visible}>
        <span className={styles.play}>play</span>
      </div>
      <svg className={'cursorTrail'} ref={trailRef}></svg>
    </>
  );
};

export const Cursor = () => {
  const isMobile = useIsMobile();

  if (isMobile) return null;

  return <CursorInner />;
};
